import React, { useEffect } from 'react';
import { Box, Text, VStack, HStack, IconButton, Popover, PopoverTrigger, PopoverContent, PopoverBody, SimpleGrid, Icon, Tooltip, Input } from '@chakra-ui/react';
import { Reorder } from 'framer-motion';
import { AddIcon, DragHandleIcon } from '@chakra-ui/icons';
import { iconRepository, getLocalizedIcon, getIconById } from '../data/iconRepository';

const IconSequencer = ({ exercises, setExercises, availableIcons, isDarkMode }) => {

    const handleSelect = (uniqueId, newIconId) => {
        const newExercises = exercises.map(ex =>
            ex.uniqueId === uniqueId ? { ...ex, iconId: newIconId } : ex
        );
        setExercises(newExercises);
    };

    return (
        <VStack spacing={2} w="100%" mt={4} bg="transparent" p={4} borderRadius="xl" border="1px solid" borderColor={isDarkMode ? "gray.700" : "gray.100"} boxShadow="sm">
            <HStack w="100%" justifyContent="space-between">
                <Text fontSize="md" fontWeight="bold" color={isDarkMode ? "white" : "gray.800"}>Sequenza Round</Text>
                <Text fontSize="xs" color={isDarkMode ? "gray.500" : "gray.400"}>Trascina per ordinare</Text>
            </HStack>

            <Reorder.Group
                axis="y"
                values={exercises}
                onReorder={setExercises}
                style={{ width: '100%', listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}
            >
                {exercises.map((exercise, index) => {
                    const iconData = exercise.iconId ? getLocalizedIcon(getIconById(exercise.iconId)) : null;

                    return (
                        <Reorder.Item
                            key={exercise.uniqueId}
                            value={exercise}
                            style={{ background: isDarkMode ? '#374151' : 'white', borderRadius: '8px', zIndex: 1 }}
                            whileDrag={{ scale: 1.05, boxShadow: "0px 5px 15px rgba(0,0,0,0.1)", zIndex: 2 }}
                        >
                            <HStack
                                p={2}
                                bg={isDarkMode ? "gray.700" : "gray.50"}
                                borderRadius="md"
                                border="1px solid"
                                borderColor={isDarkMode ? "gray.600" : "gray.200"}
                                justifyContent="space-between"
                            >
                                <HStack spacing={3}>
                                    <Box cursor="grab" color={isDarkMode ? "gray.400" : "gray.400"} _active={{ cursor: "grabbing" }}>
                                        <DragHandleIcon />
                                    </Box>
                                    <Text fontSize="sm" fontWeight="bold" color={isDarkMode ? "gray.300" : "gray.500"} w="20px">{index + 1}</Text>

                                    <Popover isLazy placement="right">
                                        <PopoverTrigger>
                                            <IconButton
                                                icon={iconData ? <Icon as={iconData.icon} /> : <AddIcon />}
                                                aria-label="Select Icon"
                                                variant={iconData ? "solid" : "outline"}
                                                colorScheme={iconData ? "teal" : "gray"}
                                                size="sm"
                                                borderRadius="full"
                                            />
                                        </PopoverTrigger>
                                        <PopoverContent w="300px" bg={isDarkMode ? "gray.800" : "white"}>
                                            <PopoverBody>
                                                <Text fontSize="sm" fontWeight="bold" mb={2} color={isDarkMode ? "white" : "gray.800"}>Scegli Icona</Text>
                                                <SimpleGrid columns={4} spacing={2}>
                                                    {availableIcons.map(icon => (
                                                        <Tooltip label={icon.name} key={icon.id}>
                                                            <IconButton
                                                                icon={<Icon as={icon.icon} color={isDarkMode ? "teal.300" : "teal.500"} />}
                                                                variant="ghost"
                                                                onClick={() => handleSelect(exercise.uniqueId, icon.id)}
                                                                _hover={{ bg: isDarkMode ? "gray.700" : "gray.100" }}
                                                            />
                                                        </Tooltip>
                                                    ))}
                                                </SimpleGrid>
                                                {availableIcons.length === 0 && <Text fontSize="xs" color="red.400">Nessuna icona scaricata.</Text>}
                                            </PopoverBody>
                                        </PopoverContent>
                                    </Popover>

                                    <Input
                                        placeholder="Nome esercizio..."
                                        value={exercise.customLabel || ''}
                                        onChange={(e) => {
                                            const newExercises = exercises.map(ex =>
                                                ex.uniqueId === exercise.uniqueId ? { ...ex, customLabel: e.target.value } : ex
                                            );
                                            setExercises(newExercises);
                                        }}
                                        size="sm"
                                        variant="flushed"
                                        width="150px"
                                        onClick={(e) => e.stopPropagation()}
                                        color={isDarkMode ? "white" : "gray.800"}
                                        _placeholder={{ color: isDarkMode ? "gray.500" : "gray.400" }}
                                    />
                                    <Text fontSize="sm" fontWeight="medium" color={isDarkMode ? "gray.400" : "gray.500"} fontStyle="italic">
                                        {iconData ? `(${iconData.name})` : ""}
                                    </Text>
                                </HStack>
                            </HStack>
                        </Reorder.Item>
                    );
                })}
            </Reorder.Group>
        </VStack>
    );
};

export default IconSequencer;
